import type { CSSProperties } from 'react';
import { formatPeso } from '@tahi/core';
import { cn } from './cn';
import { useTick } from './useTick';

export interface MoneyProps {
  minor: number;
  cents?: 'always' | 'auto';
  animate?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function Money({ minor, cents = 'always', animate = true, className, style }: MoneyProps) {
  const shown = useTick(minor, animate);
  return (
    <span className={cn('font-mono tabular-nums', className)} style={style}>
      {formatPeso(Math.round(shown), { cents })}
    </span>
  );
}
